<div [hidden]="!includeLabel">
  <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
  <div *ngIf="filterMode == dateFormatType.idrmDate" class='input-group'>
    <input ngbDatepicker #d2="ngbDatepicker" #field class="form-control" placeholder="{{placeholderMask}}" type='text'
      [id]="(id === null ? name : id)" [name]="name" [value]="value" [disabled]="readOnly"
      (dateSelect)="onDateChange($event)" (input)="changeValue($event)" (keyup)="pressKey($event)" />
    <div class="input-group-append">
      <div class="input-group-text" (click)="d2.toggle()">
        <i class="fa fa-calendar" style="cursor: pointer;"></i>
      </div>
    </div>
  </div>

  <div *ngIf="filterMode == dateFormatType.idrmTime" class='input-group timepicker'>
    <input type="time" #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [value]="value"
      [disabled]="readOnly" (input)="changeValue($event)" />
  </div>
</ng-template>
<ng-template #showSpan>
  <span type="text" #field [id]="(id === null ? name : id)">
    {{formatDateDetailMode()}}
  </span>
  <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode">
  <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
  <app-input-feedback [hidden]="!validateValidDate()" [feedbackMessage]="spanInvalidDate"></app-input-feedback>
</div>
